/**
 * Kinng.app — Cobrança (Stripe).
 * Todas as rotas usam o token do tenant e funcionam mesmo com o acesso
 * bloqueado (backend: get_current_tenant_user_open).
 */
import { api } from "./api";

export const billingApi = {
    status: () => api.get("/billing/status"),
    checkout: () => api.post("/billing/checkout", {}),   // assinatura cartão → { url }
    portal: () => api.post("/billing/portal", {}),       // portal do cliente Stripe → { url }
    pix: () => api.post("/billing/pix", {}),             // Pix avulso → { url }
    session: (id) => api.get(`/billing/session/${id}`),  // polling de uma Checkout Session
};

export default billingApi;
